/* @flow */
import Button from 'components/Button';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import PropTypes from 'prop-types';
import * as React from 'react';

import cx from 'classnames';
import './styles/GroupMessageHeaderAction.scss';

class GroupMessageHeaderAction extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    color: PropTypes.oneOf(['lava', 'brand']),
  };

  static propClasses = {
    color: {
      lava: 'GroupMessageHeaderAction-lava',
      brand: 'GroupMessageHeaderAction-brand',
    },
  };

  static defaultProps = {
    color: 'brand',
  };

  render() {
    return (
      <Button
        className={cx('GroupMessageHeaderAction', getPropClassesFromInstance(this))}
        level="text"
        size="small"
        data-test-selector={`group-message-header-action-${this.props.color}`}
        onClick={this.props.onClick}>
        {this.props.children}
      </Button>
    );
  }
}

export default GroupMessageHeaderAction;
